import styled from 'styled-components'

import { COLORS, typeScale } from '../../styles'

const Styled = styled.div`
  padding: 1.6rem;
  border-radius: 1.6rem;
  background-color: ${COLORS.powder};
  color: ${COLORS.black};
`
Styled.headline = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 0.8rem;
`
Styled.badge = styled.span`
  ${typeScale('caption')};
  display: inline-block;
  margin-right: 0.8rem;
  border-radius: 9999px;
  padding: 0.4rem 0.8rem;
  background-color: ${COLORS.white};
  color: ${COLORS.black};
`
Styled.authorImage = styled.img`
  border-radius: 9999px;
  overflow: hidden;
  width: 3.2rem;
  height: 3.2rem;
  object-fit: cover;
  object-position: center center;
`
Styled.description = styled.p`
  ${typeScale('caption')};
  color: ${COLORS.black};
  width: 100%;
  text-align: left;
`
Styled.authorName = styled.p`
  ${typeScale('caption')};
  color: ${COLORS.black};
  width: 100%;
  text-align: right;
  padding-top: 0.8rem;
`
export default Styled
